import {Injectable} from '@angular/core';
import {DataService} from "../../../services";
import {ApiService} from "../../../global/services";
import {InventUserDTO, InventUserSearchDTO} from "../../../interfaces/auction-import/invent-user.interface";
import {TypedSearchResultDTO, TypedValidatedResultDTO} from "../../../global/interfaces";
import {compare} from "fast-json-patch";

@Injectable()
export class InventUserService {

  private serviceUrl = '/api/invent-user';

  constructor(
    private apiClient: ApiService,
    private data: DataService) {
  }

  /**
   * Search for invent users with filtering and pagination
   */
  search(query: InventUserSearchDTO): Promise<TypedSearchResultDTO<InventUserDTO>> {
    const url = `${this.data.apiUrl}${this.serviceUrl}`;
    return this.apiClient.get({url}, {query}) as Promise<TypedSearchResultDTO<InventUserDTO>>;
  }

  /**
   * Get a specific invent user by ID
   */
  get(id: string): Promise<InventUserDTO> {
    const url = `${this.data.apiUrl}${this.serviceUrl}/${id}`;
    return this.apiClient.get({url}) as Promise<InventUserDTO>;
  }

  /**
   * Create a new invent user
   */
  create(dto: any): Promise<TypedValidatedResultDTO<InventUserDTO>> {
    const url = `${this.data.apiUrl}${this.serviceUrl}/create`;
    return this.apiClient.post({url, data: dto}) as Promise<TypedValidatedResultDTO<InventUserDTO>>;
  }

  /**
   * Update an existing invent user using JSON patch
   */
  patch(id: string, dto: any, previousDTO?: any): Promise<TypedValidatedResultDTO<InventUserDTO>> {
    const patch = compare(previousDTO || {}, dto);
    const url = `${this.data.apiUrl}${this.serviceUrl}/${id}`;
    return this.apiClient.patch({url, data: patch}) as Promise<TypedValidatedResultDTO<InventUserDTO>>;
  }

  /**
   * Delete an invent user
   */
  delete(id: string): Promise<any> {
    const url = `${this.data.apiUrl}${this.serviceUrl}/${id}`;
    return this.apiClient.delete({url});
  }

  /**
   * Get all invent users (for dropdowns, etc.)
   */
  getAll(): Promise<InventUserDTO[]> {
    const url = `${this.data.apiUrl}${this.serviceUrl}/all`;
    return this.apiClient.get({url}) as Promise<InventUserDTO[]>;
  }
}
